import { render, staticRenderFns } from "./signature.vue?vue&type=template&id=1c6b630e&scoped=true&"
import script from "./signature.vue?vue&type=script&lang=ts&"
export * from "./signature.vue?vue&type=script&lang=ts&"
import style0 from "./signature.vue?vue&type=style&index=0&id=1c6b630e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6b630e",
  null
  
)

export default component.exports